import { render, staticRenderFns } from "./OptionGroupsSidebar.vue?vue&type=template&id=c204bf04&scoped=true"
import script from "./OptionGroupsSidebar.vue?vue&type=script&lang=js"
export * from "./OptionGroupsSidebar.vue?vue&type=script&lang=js"
import style0 from "./OptionGroupsSidebar.vue?vue&type=style&index=0&id=c204bf04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c204bf04",
  null
  
)

export default component.exports